import { render, staticRenderFns } from "./vue-week-picker.vue?vue&type=template&id=2e49189f&scoped=true"
import script from "./vue-week-picker.vue?vue&type=script&lang=js"
export * from "./vue-week-picker.vue?vue&type=script&lang=js"
import style0 from "./vue-week-picker.vue?vue&type=style&index=0&id=2e49189f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49189f",
  null
  
)

export default component.exports